import { createSlice } from "@reduxjs/toolkit";

const initialKecamatanState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  kecamatanForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const kecamatanSlice = createSlice({
  name: "kecamatan",
  initialState: initialKecamatanState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    kecamatanFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    kecamatanAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    kecamatanCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.kecamatan.push(action.payload.kecamatan);
    },
    kecamatanDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.kecamatan.filter(
        (el) => el.kecamatan_id !== action.payload.id
      );
    },
    getKecamatan: (state, action) => {
      state.actionsLoading = false;
      state.kecamatanForEdit = action.payload.kecamatanForEdit;
      state.error = null;
    },
    // updateProduct
    kecamatanUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.kecamatan = state.entities.kecamatan.map((entity) => {
        if (entity.kecamatan_id === action.payload.kecamatan.kecamatan_id) {
          return action.payload.kecamatan;
        }
        return entity;
      });
    },
  },
});
